import React, { Component } from 'react';
import './FoodItemPage.css';
import Ingredients from './components/Ingredients';
import Steps from './components/Steps';
import Description from './components/Description';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default class FoodItemPage extends Component {
  constructor(props) {
    super(props);

    this.widget = window.cloudinary.createUploadWidget(
      {
        cloudName: 'dtp68ybqr',
        uploadPreset: 'zxloubyq',
      },
      (error, result) => {
        this.checkUpdateResult(result);
      }
    );

    this.state = {
      imgSrc: '',
      edit: false,
      pwInput: '',
      pwDisplay: false,
    };
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRatingClick = this.handleRatingClick.bind(this);
    this.handleCountClick = this.handleCountClick.bind(this);
    this.pageDisplayStyle = this.pageDisplayStyle.bind(this);
    this.displayPassword = this.displayPassword.bind(this);
    this.typePassword = this.typePassword.bind(this);
    this.submitPassword = this.submitPassword.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
  }

  handleEditClick() {
    this.displayPassword();
    this.setState({ edit: !this.state.edit });
  }
  handleRatingClick() {
    this.props.changeItem(
      this.props.foodItem.id,
      'rating',
      parseInt(this.props.foodItem.rating) + 1
    );
  }
  handleCountClick() {
    this.props.changeItem(
      this.props.foodItem.id,
      'count',
      parseInt(this.props.foodItem.count) + 1
    );
  }

  submitPassword(e) {
    e.preventDefault();
    this.displayPassword();
  }

  handleImageClick() {
    if (this.state.edit) {
      this.showWidget(this.widget);
    }
  }

  displayPassword() {
    if (this.state.pwInput !== this.props.pass) {
      this.setState({ pwDisplay: !this.state.pwDisplay, edit: false });
    } else {
      this.setState({ pwDisplay: false });
    }
  }

  showWidget(widget) {
    widget.open();
  }

  checkUpdateResult = (resultEvent) => {
    if (resultEvent.event === 'success') {
      this.setState({ imgSrc: resultEvent.info.secure_url });
      this.props.changeItem(
        this.props.foodItem.id,
        'src',
        resultEvent.info.secure_url
      );
    }
  };

  typePassword(e) {
    let value = e.target.value;
    this.setState({ pwInput: value });
  }

  pageDisplayStyle() {
    return { display: this.props.display ? 'flex' : 'none' };
  }

  handleClick() {
    this.props.onClick(this.props.index);
  }

  render() {
    return (
      <div className="food-item-page-outer" style={this.pageDisplayStyle()}>
        <div
          className="password"
          style={
            this.state.pwDisplay ? { display: 'flex' } : { display: 'none' }
          }
        >
          <form action="" onSubmit={this.submitPassword}>
            <p>Bitte Passwort eingeben, damit keine Rezepte verloren gehen:</p>

            <input
              type="text"
              name="password"
              id="password"
              onChange={this.typePassword}
              placeholder="Passwort.."
            />
            <div className="btns">
              <div className="btn" onClick={this.displayPassword}>
                Senden
              </div>
              <div className="btn" onClick={this.displayPassword}>
                Abbrechen
              </div>
            </div>
          </form>
        </div>

        <div className="food-item-page">
          <div onClick={this.handleClick} className="close">
            x
          </div>
          <div
            onClick={this.handleImageClick}
            className="img"
            style={{
              background: 'url(' + this.props.foodItem.src + ')',
              cursor: this.state.edit ? 'pointer' : 'auto',
            }}
          ></div>
          <h1>{this.props.foodItem.name}</h1>
          <h2>{this.props.foodItem.category}</h2>
          <div className="btn-area">
            <div className="btn-gray done" onClick={this.handleCountClick}>
              {this.props.foodItem.count} <FontAwesomeIcon icon={faCheck} />
            </div>
            <div className="btn-gray like" onClick={this.handleRatingClick}>
              {this.props.foodItem.rating} <FontAwesomeIcon icon={faThumbsUp} />
            </div>
            <div className="btn-gray edit" onClick={this.handleEditClick}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </div>

          <div className="content-wrapper">
            <Description
              edit={this.state.edit}
              id={this.props.id}
              onClick={this.props.changeItem}
              description={this.props.foodItem.description}
            />
            <Ingredients
              ingredients={this.props.foodItem.ingredients}
              onClick={this.props.changeItem}
              id={this.props.id}
              edit={this.state.edit}
            />
            <Steps
              steps={this.props.foodItem.steps}
              onClick={this.props.changeItem}
              id={this.props.id}
              edit={this.state.edit}
            />
          </div>
        </div>
      </div>
    );
  }
}
